import { Component, Prop, h, State, Event, EventEmitter } from '@stencil/core';
import { ButtonVariant, ButtonSize, ButtonState } from './types';

@Component({
  tag: 'vsr-icon-button-v2',
  styleUrl: 'vsr-button.scss',
  shadow: true,
})
export class VsrIconButton {
  @Prop() variant: ButtonVariant = 'primary';
  @Prop() size: ButtonSize = 'M';
  @Prop() state: ButtonState = 'active';
  @Prop() disabled: boolean = false;

  @State() isFocused: boolean = false;

  @Event() vsrClick: EventEmitter<MouseEvent>;

  private handleClick = (event: MouseEvent) => {
    this.vsrClick.emit(event);
  };

  render() {
    const buttonClass = `icon-button ${this.variant} ${this.size.toLowerCase()} ${this.state.toLowerCase()} ${this.isFocused ? 'focused' : ''}`;

    return (
      <button
        class={buttonClass}
        onClick={this.handleClick}
        disabled={this.state === 'inactive' || this.disabled}
        onFocus={() => (this.isFocused = true)}
        onBlur={() => (this.isFocused = false)}
        aria-disabled={this.state === 'inactive' || this.disabled}
      >
        <slot></slot>
        {this.isFocused && <div class="focus-ring"></div>}
      </button>
    );
  }
}
